import {injectIntl} from 'react-intl';
import {createElement, PropTypes} from 'rlink-react';

import DocumentComponent from 'rlink-react-document/DocumentComponent.jsx';

class DocumentFacebookProperty extends DocumentComponent {

  get documentSlot () {
    return 'head';
  }

  get tagName () {
    return 'meta';
  }

  get keyAttributeNames () {
    return ['property'];
  }

  get attributes () {
    return {
      property: `fb:${this.props.property}`,
      value: this.formatMessage(this.props.value),
    };
  }
}

DocumentFacebookProperty.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.shape({
      id: PropTypes.string,
      defaultMessage: PropTypes.destring,
      description: PropTypes.string,
    }),
  ]).isRequired,
};

export default injectIntl(DocumentFacebookProperty);



// WEBPACK FOOTER //
// ./lib/rlink-react-document/DocumentFacebookProperty.jsx